import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { DepositSuggestions, PaySystems } from '../../types/Cashier';
import { getPaySystemName } from '../../utils/cashier';
import PaymentMethodLogo from '../PaymentMethodLogo/PaymentMethodLogo';

import {
  TXTWCL_Try_an_alternative_method_to_m_ELL,
  TXTWCL_We_suggest_that_you_use_N0_or__ELL
} from './SuggestedPayments.messages.json';
import { content, logoContainer } from './SuggestedPayments.scss';

interface Props {
  suggestedPayments: DepositSuggestions;
  paySystems: PaySystems;
}

const SuggestedPayments: React.FC<Props> = ({ paySystems, suggestedPayments }) => (
  <>
    <Typography>
      {suggestedPayments.length === 1 ? (
        <Translation
          {...TXTWCL_Try_an_alternative_method_to_m_ELL}
          values={{
            0: getPaySystemName(paySystems, suggestedPayments[0]?.cardType)
          }}
        />
      ) : (
        <Translation
          {...TXTWCL_We_suggest_that_you_use_N0_or__ELL}
          values={{
            0: getPaySystemName(paySystems, suggestedPayments[0]?.cardType),
            1: getPaySystemName(paySystems, suggestedPayments[1]?.cardType)
          }}
        />
      )}
    </Typography>
    <div className={logoContainer}>
      <div className={content}>
        {suggestedPayments.length === 1 ? (
          <PaymentMethodLogo cardType={suggestedPayments[0]?.cardType} />
        ) : (
          <>
            <PaymentMethodLogo cardType={suggestedPayments[0]?.cardType} />
            <Divider orientation="vertical" />
            <PaymentMethodLogo cardType={suggestedPayments[1]?.cardType} />
          </>
        )}
      </div>
    </div>
  </>
);

export default SuggestedPayments;
